import { CardTextDto } from "@dtos/card-text.dto";
import { BaseConverter } from "./BaseConverter";
import { CardText } from "@models/card-text.model";
import { CardInfoConverter } from "./cardInfoConverter";


export class CardTextConverter extends BaseConverter<CardText, CardTextDto>{
    
    private cardInfoConverter = new CardInfoConverter()

    modelToDto(model: CardText): CardTextDto {
        return new CardTextDto(
            model.id,
            model.textDetail,
            model.locale,
            model.photo,
            model.cardInfo ? this.cardInfoConverter.modelToDto(model.cardInfo) : undefined
        )
    }

    dtoToModel(dto: CardTextDto): CardText {
        return new CardText(
            dto.id,
            dto.textDetail,
            dto.locale,
            dto.photo,
            dto.cardInfo ? this.cardInfoConverter.dtoToModel(dto.cardInfo) : undefined
        )
    }
}